import { ReactNode } from 'react';
import styles from './PolicyViewerHeader.module.css';

export type ViewerMode = 'view' | 'edit';

interface PolicyViewerHeaderProps {
	mode: ViewerMode;
	children: ReactNode;
}

export const PolicyViewerHeader = ({ mode, children }: PolicyViewerHeaderProps) => {
	const getModeLabel = () => {
		switch (mode) {
			case 'view':
				return 'MODO DE VISUALIZAÇÃO';
			case 'edit':
				return 'MODO DE EDIÇÃO';
		}
	};

	return (
		<header className={styles.viewerHeader}>
			<div className={styles.viewerHeaderMain}>
				<span className={styles.viewerLabel}>{getModeLabel()}</span>
			</div>
			<div className={styles.viewerControls}>{children}</div>
		</header>
	);
};
